import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { FileUpDownloadController } from '@shared/src/controllers/fileupdownload/fileupdownload.controller';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { RouteCMRController } from '@shared/src/controllers/route/cmr/routecmr.controller';
import { RoutePartCMRSignatureAgents } from '@shared/src/controllers/route/cmr/RoutePartCMRSignatureAgents';
import { PhaseController } from '@shared/src/controllers/route/phase/phase.controller';
import { HLong } from '@shared/src/datatypes/HLong';
import { ActionDto } from '@shared/src/dtos/maintenance/action/actionDto';
import { ActionsStripDto } from '@shared/src/dtos/maintenance/action/ActionsStripDto';
import { OptionDto } from '@shared/src/dtos/maintenance/option/OptionDto';
import { OptionsStripDto } from '@shared/src/dtos/maintenance/option/OptionsStripDto';
import { RoutePartCMRDto } from '@shared/src/dtos/route/cmr/RoutePartCMRDto';
import { AlertService } from '@shared/src/public-api';

@Component({
  selector: 'shared-phase-cmr-edit',
  templateUrl: './shared.phase.cmr.edit.component.html',
  styleUrls: ['./shared.phase.cmr.edit.component.scss'],
})
export class SharedPhaseCMREditComponent {

  constructor(@Inject('HomeController') protected homeController: HomeController,
    @Inject('AlertService') protected alertService: AlertService,
    private routeCMRController: RouteCMRController, private phaseController: PhaseController) {

  };

  @Input() public readonly: boolean = false;

  public __phaseId: number = 0;
  @Input()
  set phaseId(value: number) {
    if (this.__phaseId === value)
      return;
    this.__phaseId = value;
    this.loadData();
  }
  get phaseId(): number {
    return this.__phaseId;
  }

  ngOnInit() {

  }

  public options: OptionsStripDto | null = null;
  public actions: ActionsStripDto | null = null;
  public selectedRoutePartCMR: RoutePartCMRDto = null;

  public clickOption(option: OptionDto) {
    this.loadRoutePartCMRData(option != null ? this.getFirstNumber(option.optionId) : 0);
  }
  public getFirstNumber(input: string): number {
      return parseInt(input.split('.')[0], 10);
  }
  
  public loadData() {
    if (!HLong.isNullOrNullLong(this.__phaseId))
      this.routeCMRController.getRoutePartCMRsByPhaseId(this.__phaseId).subscribe(d => {
        let routeCMRParts = d;

        this.options = new OptionsStripDto();
        let visualitzarMenuBarra = 1;
          if (routeCMRParts != null && routeCMRParts.length > 3)
              visualitzarMenuBarra = 0;
        let i = 1;
        let existsRoutePartSelected : boolean = false;
        if (routeCMRParts != null && routeCMRParts.length > 0) {
          routeCMRParts.forEach(element => {
            if(!existsRoutePartSelected && this.selectedRoutePartCMR != null && element.routePartCMRId == this.selectedRoutePartCMR.routePartCMRId)
              existsRoutePartSelected = true;
          });
        }
        if(!existsRoutePartSelected)
          this.selectedRoutePartCMR = null;

        if (routeCMRParts != null && routeCMRParts.length > 0) {
          this.loadActions();

          routeCMRParts.forEach(element => {
            let selected = this.selectedRoutePartCMR == null ? i == 1 : this.selectedRoutePartCMR.routePartCMRId == element.routePartCMRId;
            this.options.add(OptionDto.build(element.routePartCMRId + ".", i.toString(), i.toString(), "fa-file-text", i, 0, visualitzarMenuBarra, selected, false));
            if (selected)
                this.clickOption(this.options.getActualSelected());
            i++;
          });
        }

        this.clickOption(this.options.getActualSelected());
      });
  }

  @Output() routePartCMRUpdated: EventEmitter<RoutePartCMRDto> = new EventEmitter();
  public onRoutePartCMRUpdated(value: RoutePartCMRDto) {
    if (this.selectedRoutePartCMR === value)
      return;

    this.selectedRoutePartCMR = value;
  
    this.routePartCMRUpdated.next(this.selectedRoutePartCMR);
  }
  public onRefreshRoutePartCMR(value: boolean) {
    if (!value)
      return;
    this.loadRoutePartCMRData(0);
  }
  @Output() routeRefresh: EventEmitter<boolean> = new EventEmitter();
  public loadRouteData() {
    this.routeRefresh.next(true);
  }

  public loadRoutePartCMRData(routePartCMRId: number) {
    let value: number = 0;
    if(!HLong.isNullOrNullLong(routePartCMRId)){
      value = routePartCMRId;
    }else if (this.selectedRoutePartCMR) {
      value = this.selectedRoutePartCMR.routePartCMRId;
    }

    if (HLong.isNullOrNullLong(value)) {
      return;
    }
    this.routeCMRController.getPhaseRoutePartCMR(value).subscribe(routePartCMR => {
      if (routePartCMR) {
        if (routePartCMR.optionsView != null){
          routePartCMR.optionViewId = "DIGITALDOCUMENT";
          OptionsStripDto.unselect(routePartCMR.optionsView);    
          OptionsStripDto.selectById(routePartCMR.optionsView, routePartCMR.optionViewId);
          routePartCMR.optionsView = OptionsStripDto.buildFromOptionsStripDto(routePartCMR.optionsView);
        }
        this.onRoutePartCMRUpdated(routePartCMR);
      }
    });
  }

  public loadActions() {
      this.actions = new ActionsStripDto();
      this.actions.add(ActionDto.build("CREATEPDF", "SHAREDPHASECMR.CREATEPDF.CAPTION", "SHAREDPHASECMR.CREATEPDF.HELP", "fa-file-pdf-o", 10, 0, 0, ""));
  }

  public clickAction(action: ActionDto) {
    switch (action.actionId) {
      case "CREATEPDF":
        if (!HLong.isNullOrNullLong(this.phaseId))
          return this.phaseController.getPhasePDF(this.phaseId).subscribe(d => {
            FileUpDownloadController.resultDownLoad(d);
          });
        break;
    }
  }

  public pretty(value: any): string {
    return JSON.stringify(value);
  }
}
